import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./auth/Login";
import DashboardRoutes from "./routes/DashboardRoutes.js";
import WebAppRoutes from "./routes/WebAppRoutes.js";
import PublicRoute from "./routes/PublicRoute.jsx";
import NotFound from "./components/NotFound/NotFound.jsx";
import Register from "./auth/Register.js";
import VerifyOtp from "./auth/verifyOtp.js";
import ForgotPassword from "./auth/Forgot-Password/ForgotPassword.js";
import ResetPassword from "./auth/Forgot-Password/ResetPassword.js";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginOtp from "./auth/Login-Otp/LoginOtp.js";
import VerifyLoginOtp from "./auth/Login-Otp/VerifyOtp.js";
import GlobalLogoLoader from "./src/components/Preloader/Preloader.jsx";
import "./App.css";
function App() { 
    const location = useLocation();
const [loading, setLoading] = useState(false);
useEffect(() => {
  setLoading(true);

  const timer = setTimeout(() => {
    setLoading(false);
  }, 500);

  return () => clearTimeout(timer);
}, [location.pathname]);
if (loading) {
  return <GlobalLogoLoader />;
}
  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route path="/verify-otp" element={
        <PublicRoute>
          <VerifyOtp />
        </PublicRoute>
      } />

      <Route path="/forgot-password" element={
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      } />
      <Route path="/reset-password" element={
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      } />

      <Route path="/login/otp" element={
        <PublicRoute>
          <LoginOtp />
        </PublicRoute>
      } />
      <Route path="/login/otp/verify" element={
        <PublicRoute>
          <VerifyLoginOtp />
        </PublicRoute>
      } />

      {/* Protected dashboard routes */}
      <Route path="/admin/*" element={<DashboardRoutes />} />


      {/* Web app frontend routes */}
      <Route path="/*" element={<WebAppRoutes />} />


      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
export default App;